<template>
	<ButtonLayout class="teaming-button2" @click="onClick" :disabled="isDisabled">
		<div class="main">
			<div v-if="$slots[ `left-icon` ]" class="left-icon">
				<slot name="left-icon"></slot>
			</div>
			<div class="text">
				<slot></slot>
			</div>
			<div v-if="$slots[ `right-icon` ]" class="right-icon">
				<slot name="right-icon"></slot>
			</div>
		</div>
	</ButtonLayout>
</template>

<script>
import ButtonLayout from "./ButtonLayout.vue";

export default {
	name: "TeamingButton2",
	emits: [ "buttonPress", ],
	components: {
		ButtonLayout,
	},
	props: {
		isDisabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		/**
		 * @deprecated
		 * NOTE: maintained for backwards compatability with TeamingButton;
		 * prefer normal click event instead.
		 * @param e
		 */
		onClick( e ) {
			if ( this.isDisabled ) {
				e.preventDefault();
				e.stopPropagation();
				return;
			}
			this.$emit( "buttonPress", e );
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-button2 .main {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
}

.teaming-button2 .text {
	font-weight: 600;
}

.teaming-button2 .left-icon,
.teaming-button2 .right-icon {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
}
</style>
